var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3105 16.001L9.1949 9.88537C8.70659 10.3014 8.14503 10.6234 7.51022 10.8512C6.87542 11.0791 6.23736 11.1931 5.59605 11.1931C4.03215 11.1931 2.7085 10.6517 1.6251 9.56894C0.5417 8.48555 0 7.16222 0 5.59898C0 4.03573 0.541048 2.71175 1.62315 1.62705C2.70589 0.5417 4.02889 -0.000976562 5.59214 -0.000976562C7.15604 -0.000976562 8.48034 0.540723 9.56504 1.62412C10.6497 2.70752 11.1921 4.0315 11.1921 5.59605C11.1921 6.27447 11.072 6.93109 10.8317 7.56589C10.5908 8.2007 10.275 8.7437 9.88439 9.1949L16 15.3095L15.3095 16.001H15.3105ZM5.59605 10.2155C6.8917 10.2155 7.98584 9.76948 8.87847 8.8775C9.77045 7.98551 10.2164 6.89137 10.2164 5.59507C10.2164 4.29942 9.77045 3.2056 8.87847 2.31362C7.98649 1.42164 6.89267 0.975646 5.59702 0.975646C4.30137 0.975646 3.20723 1.42164 2.31459 2.31362C1.42261 3.2056 0.976622 4.29942 0.976622 5.59507C0.976622 6.89072 1.42261 7.98454 2.31459 8.87652C3.20658 9.7685 4.30039 10.2155 5.59605 10.2155Z",
    fill: "#C9C9CA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Search.b1a0487a.svg";
export { ForwardRef as ReactComponent };